/**
 * Hub 站内搜索索引（全语言共用）
 * 新增文章/区块类型时，优先在这里扩展 collectBlockText。
 */

function uniq(items) {
  var seen = {}
  var out = []
  var i
  for (i = 0; i < items.length; i++) {
    var item = String(items[i] || '').trim()
    if (!item || seen[item]) continue
    seen[item] = true
    out.push(item)
  }
  return out
}

function containsHan(text) {
  return /[\u4e00-\u9fff]/.test(String(text || ''))
}

function containsCjk(text) {
  return containsHan(text)
}

function filterInheritedSearchTerms(terms, locale, stripChineseForNonZh) {
  if (locale === 'zh' || !stripChineseForNonZh) return terms
  return terms.filter(function (term) {
    var value = String(term || '').trim()
    if (!value) return false
    if (!containsHan(value)) return true
    if (/[A-Za-z0-9]/.test(value)) return true
    return false
  })
}

function normalizeSearchQuery(query) {
  return String(query || '').trim().toLowerCase()
}

function pushText(parts, value) {
  var text = String(value || '').trim()
  if (text) parts.push(text)
}

function collectBlockText(block, parts) {
  if (!block || !block.type) return
  switch (block.type) {
    case 'paragraph':
      pushText(parts, block.text)
      break
    case 'bullets':
    case 'prompts':
      var bi
      for (bi = 0; bi < (block.items || []).length; bi++) {
        pushText(parts, block.items[bi])
      }
      break
    case 'faq-item':
      pushText(parts, block.question)
      pushText(parts, block.answer)
      break
    case 'scenario-item':
      pushText(parts, block.title)
      pushText(parts, block.text)
      break
    case 'tip':
      pushText(parts, block.title)
      pushText(parts, block.text)
      break
    case 'prompt-example':
      pushText(parts, block.label)
      pushText(parts, block.prompt)
      break
    case 'cta':
      pushText(parts, block.title)
      pushText(parts, block.text)
      pushText(parts, block.buttonLabel)
      break
    case 'links':
      pushText(parts, block.title)
      var li
      for (li = 0; li < (block.items || []).length; li++) {
        pushText(parts, block.items[li].label)
      }
      break
    case 'table':
      pushText(parts, (block.columns || []).join(' '))
      var ri
      for (ri = 0; ri < (block.rows || []).length; ri++) {
        var row = block.rows[ri] || []
        var ci
        for (ci = 0; ci < row.length; ci++) {
          pushText(parts, row[ci])
        }
      }
      break
    case 'figure':
      pushText(parts, block.alt)
      pushText(parts, block.caption)
      break
    case 'gallery':
      pushText(parts, block.caption)
      break
    default:
      break
  }
}

function collectSectionText(sections) {
  var parts = []
  var i
  var j
  sections = sections || []
  for (i = 0; i < sections.length; i++) {
    pushText(parts, sections[i].title)
    var blocks = sections[i].blocks || []
    for (j = 0; j < blocks.length; j++) {
      collectBlockText(blocks[j], parts)
    }
  }
  return parts.join(' ')
}

function collectArticleMetaText(article) {
  var parts = []
  pushText(parts, article.title)
  pushText(parts, article.excerpt)
  pushText(parts, article.metaDescription)
  if (article.slug) {
    pushText(parts, article.slug.replace(/-/g, ' '))
  }
  if (article.target) {
    pushText(parts, article.target.label)
    pushText(parts, article.target.path)
  }
  pushText(parts, article.category)
  return parts.join(' ')
}

function collectListText(list) {
  var parts = []
  var i
  for (i = 0; i < (list || []).length; i++) {
    pushText(parts, list[i])
  }
  return parts.join(' ')
}

function collectCreatingStepsText(steps) {
  var parts = []
  var i
  for (i = 0; i < (steps || []).length; i++) {
    pushText(parts, steps[i].title)
    pushText(parts, steps[i].text)
  }
  return parts.join(' ')
}

function isSuggestionTerm(term, locale) {
  var value = String(term || '').trim()
  if (!value) return false
  if (/^(reviews|alternatives|how-to-guides|prompt-guides|ai-model-insights|all)$/.test(value)) {
    return false
  }
  if (value.length > 80) return false
  if (containsHan(value) || /[\u3040-\u309f\u30a0-\u30ff]/.test(value) || /[\uac00-\ud7af]/.test(value)) {
    return value.length >= 4
  }
  var words = value.split(/\s+/).filter(Boolean)
  if (words.length >= 3) return true
  if (value.length >= 16) return true
  if (/seedream|flux|midjourney|gpt|qwen|stable diffusion|watermark|handwriting|dewarp|discord|amazon|shopify|prompt|poster|ecommerce/i.test(value)) {
    return true
  }
  if (locale && locale !== 'zh' && locale !== 'ja' && locale !== 'ko' && words.length < 2 && value.length < 12) {
    return false
  }
  return value.length >= 10
}

// Popular-search mix: How / Can-Is / What tool / How to fix (+ other).
var SUGGESTION_TEMPLATE_ORDER = ['how', 'can', 'what', 'fix', 'other']

function classifySuggestionTemplate(term) {
  var value = String(term || '').trim()
  if (!value) return 'other'
  var lower = value.toLowerCase()

  if (
    /\bhow to fix\b|\bhow do i fix\b|\bhow can i fix\b|\bhow to solve\b/i.test(value) ||
    /怎么修复|怎么解决|如何修复|如何解决|失败怎么办/.test(value) ||
    /直し方|直し|고치는|고치기/.test(value) ||
    /comment corriger|cómo corregir|come (sistemare|correggere)|wie (behebe|korrigiere)|como corrigir|jak naprawić|كيف أصلح/.test(lower) ||
    /\bwhen (removing|generating|creating|correcting|using)\b/i.test(value)
  ) {
    return 'fix'
  }

  if (
    /^(can i|is it|can )\b/i.test(value) ||
    /^(能否|可以|是否)/.test(value) ||
    /(使える|できる|可能な)/.test(value) ||
    /(할 수 있|가능한가요|되나요\??$)/.test(value) ||
    /^(puis-je|est-ce|est-il possible)/i.test(value) ||
    /^(¿puedo|¿es posible)/i.test(value) ||
    /^(posso|è possibile)/i.test(value) ||
    /^(kann ich|ist es möglich)/i.test(value) ||
    /^(é possível|posso)\b/i.test(value) ||
    /^(czy mogę|czy można)/i.test(value) ||
    /^(هل يمكنني|هل يمكن)/.test(value)
  ) {
    return 'can'
  }

  if (
    /^what (ai )?tool\b/i.test(value) ||
    /应该用什么|用什么(AI )?工具|哪个工具|選什麼工具/.test(value) ||
    /(どのツール|どのAIツール|ツールは)/.test(value) ||
    /어떤 도구/.test(value) ||
    /^quel (outil|ai)/i.test(value) ||
    /^qué herramienta/i.test(value) ||
    /^quale strumento/i.test(value) ||
    /^welches tool/i.test(value) ||
    /^que ferramenta/i.test(value) ||
    /^jakiego narzędzia/i.test(value) ||
    /^ما (هي )?الأداة/.test(value)
  ) {
    return 'what'
  }

  if (
    /^(how to|how do i)\b/i.test(value) ||
    /^(如何|怎样|怎么)/.test(value) ||
    /(する方法|使い方|作り方)/.test(value) ||
    /(하는 방법|만드는 방법)/.test(value) ||
    /^comment\b/i.test(value) ||
    /^¿cómo\b/i.test(value) ||
    /^come\b/i.test(value) ||
    /^wie man\b/i.test(value) ||
    /^como\b/i.test(value) ||
    /^jak\b/i.test(value) ||
    /^كيف\b/.test(value)
  ) {
    return 'how'
  }

  return 'other'
}

function extractSearchTermsFromArticle(article, options) {
  options = options || {}
  var locale = options.locale || 'zh'
  var extraTerms = options.extraTerms || []
  var includeKeywords = options.includeKeywords !== false
  var stripCjkForNonZh = options.stripCjkForNonZh !== false
  var terms = []
  var sections = article.sections || []
  var scenarioTitles = []
  var faqQuestions = []
  var promptLabels = []
  var i
  var j

  for (i = 0; i < sections.length; i++) {
    var blocks = sections[i].blocks || []
    for (j = 0; j < blocks.length; j++) {
      var block = blocks[j]
      if (block.type === 'scenario-item' && block.title) {
        scenarioTitles.push(String(block.title).trim())
      } else if (block.type === 'faq-item' && block.question) {
        faqQuestions.push(String(block.question).trim())
      } else if (block.type === 'prompt-example' && block.label) {
        promptLabels.push(String(block.label).trim())
      }
    }
  }

  terms = terms.concat(scenarioTitles)
  terms = terms.concat(faqQuestions)
  terms = terms.concat(promptLabels)

  var inherited = []
  if (article.searchTerms && article.searchTerms.length) {
    inherited = inherited.concat(article.searchTerms)
  }
  if (includeKeywords && article.keywords && article.keywords.length) {
    inherited = inherited.concat(article.keywords)
  }
  if (extraTerms.length) {
    inherited = inherited.concat(extraTerms)
  }
  inherited = filterInheritedSearchTerms(inherited, locale, stripCjkForNonZh)
  terms = terms.concat(inherited)
  pushText(terms, article.title)
  if (article.target && article.target.label) {
    terms.push(String(article.target.label).trim())
  }

  return uniq(terms.filter(function (term) {
    return !!term
  }))
}

function buildArticleSearchHaystack(article, options) {
  options = options || {}
  var terms = extractSearchTermsFromArticle(article, options)
  var parts = [
    collectArticleMetaText(article),
    collectSectionText(article.sections),
    collectListText(article.keywords),
    terms.join(' '),
    collectListText(article.pros),
    collectListText(article.cons),
    collectCreatingStepsText(article.creatingSteps)
  ]
  return parts.join(' ').toLowerCase()
}

function articleMatchesQuery(article, query, options) {
  var q = normalizeSearchQuery(query)
  if (!q) return true
  return buildArticleSearchHaystack(article, options).indexOf(q) >= 0
}

function buildSearchSuggestions(articles, limit, options) {
  options = options || {}
  var locale = options.locale || 'zh'
  var max = limit || 12
  var seen = {}
  var buckets = {
    how: [],
    can: [],
    what: [],
    fix: [],
    other: []
  }
  var termLists = []
  var i
  var depth
  var key
  var term
  var out
  var progressed

  for (i = 0; i < (articles || []).length; i++) {
    termLists.push(extractSearchTermsFromArticle(articles[i], options))
  }

  for (depth = 0; depth < 120; depth++) {
    for (i = 0; i < termLists.length; i++) {
      term = termLists[i][depth]
      if (!term || seen[term]) continue
      if (!isSuggestionTerm(term, locale)) continue
      seen[term] = true
      key = classifySuggestionTemplate(term)
      buckets[key].push(term)
    }
  }

  out = []
  while (out.length < max) {
    progressed = false
    for (i = 0; i < SUGGESTION_TEMPLATE_ORDER.length; i++) {
      key = SUGGESTION_TEMPLATE_ORDER[i]
      if (!buckets[key].length) continue
      out.push(buckets[key].shift())
      progressed = true
      if (out.length >= max) return out
    }
    if (!progressed) break
  }
  return out
}

function attachArticleSearchFields(article, options) {
  options = options || {}
  article.searchTerms = extractSearchTermsFromArticle(article, options)
  return article
}

module.exports = {
  normalizeSearchQuery: normalizeSearchQuery,
  collectSectionText: collectSectionText,
  extractSearchTermsFromArticle: extractSearchTermsFromArticle,
  buildArticleSearchHaystack: buildArticleSearchHaystack,
  articleMatchesQuery: articleMatchesQuery,
  buildSearchSuggestions: buildSearchSuggestions,
  attachArticleSearchFields: attachArticleSearchFields,
  classifySuggestionTemplate: classifySuggestionTemplate
}
